import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=0c03267e&scoped=true&"
import script from "./ChatUser.vue?vue&type=script&lang=js&"
export * from "./ChatUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03267e",
  null
  
)

export default component.exports